/*
 * Objeto de estadpo Vuex.
 */
import Vue from 'vue';
import Vuex from 'vuex';

/* Elementos principales */
import * as actions from './main/actions';
import * as mutations from './main/mutations';
import * as getters from './main/getters';

/* Modules for exta functionality */
import pricingToolModule from './modules/pricingTool.module';
import mapModule from './modules/map.module';
import pixMapModule from './modules/pixMap.module';
import mandateDeprecated from './modules/mandateDeprecated.module';
import propertyModule from './modules/property.module';
import dashboardModule from './modules/dashboard.module';
import toolbarModule from './modules/toolbar.module';
import revenueUnitsModule from './modules/revenueUnits.module';
import personasModule from './modules/personas.module';
import comparablesModule from './modules/comparablesModule/comparables.module';
import genericConfigModule from './modules/genericConfig.module';
import paramListModule from './modules/paramList.module';
import auditLogModule from './modules/auditLog.module';
import comparableAuditLogModule from './modules/comparableAuditLog.module';
import loadingOverlayModule from './modules/loadingOverlay.module';
import reportModule from './modules/report.module';
import toastModule from './modules/toast.module';
import notificationsModule from './modules/notifications.module';
import researchModule from './modules/research.module';
import usersModule from './modules/users.module';
import profilesModule from './modules/profiles.module';
import rolesModule from './modules/roles.module';
import signalrModule from './modules/signalr.module';
import authModule from './modules/auth.module';
import keysModule from './modules/keys.module';
import certificationModule from './modules/certification.module';
import documentsModule from './modules/documents.module';
// Mandate
import mandateListModule from './modules/mandate/mandateList.module';
import mandateModule from './modules/mandate/mandate.module';
import mandatePropertyModule from './modules/mandate/mandateProperty.module';
import mandatePropertyListModule from './modules/mandate/mandateProperty.module';

/* Inicializacion de Vuex */
Vue.use(Vuex);

/* Vuex main store creation */
const store = new Vuex.Store({
  actions,
  mutations,
  getters,
  modules: {
    pricingToolModule,
    mapModule,
    pixMapModule,
    mandateDeprecated,
    propertyModule,
    dashboardModule,
    toolbarModule,
    revenueUnitsModule,
    personasModule,
    comparablesModule,
    genericConfigModule,
    paramListModule,
    auditLogModule,
    comparableAuditLogModule,
    loadingOverlayModule,
    reportModule,
    toastModule,
    notificationsModule,
    researchModule,
    usersModule,
    rolesModule,
    profilesModule,
    signalrModule,
    authModule,
    keysModule,
    certificationModule,
    documentsModule,
    // Mandate
    mandateListModule,
    mandateModule,
    mandatePropertyModule,
    mandatePropertyListModule,
  },
  state: {
    geaUrl: GlobalPixInitProps.geaUrl,
    langCode: 'en',
    paramListItems: [{ codParam: '*', langCode: '*', dictPairs: [{ name: '*', value: '...' }] }],
    paramListCombos: [{ paramId: -1, langCode: '*', values: [] }],
    comboDefaultIItem: {
      value: null,
      name: 'All',
    },
    userSettings: null,
    translationIsLoaded: false,
    showApp: true,
    mode: null,
  },
});
export default store;
